import Vue from 'vue';
import axios from 'axios';
import { Loading } from 'element-ui';
import { Message } from 'element-ui';
import { MessageBox } from 'element-ui';
import router from '@/router'
let myindex = 0;

let workOffTipIsShow = true;
let noUserTipIsShow = true;
let logouttime = 0;
export default {
  /**
   * 统一接口处理：get请求方法封装。this.$http.get(url, [options])
   * @param url { String } -必选 接口url
   * @param options { Object } -必选 含官方的所有options对象。传参为{params:{key:11}}
   * @param sucCb { Function } -必选 成功回调
   * @param errorCb { Function } -可选 失败回调
   * @param isLoading { Boolean } -可选 是否显示加载状态
   * @param isLogin { Boolean } -可选 是否登录信息
   */
  get: function (url, options = {}, sucCb, errorCb, isLoading = true, isLogin) {
    let loadingInstance;

    if (!url) {
      return false;
    }
    if (url.indexOf("auth/login") == -1) {
      axios.interceptors.request.use(function (config) {
        // let token = store.getters.token;
        let token = "Bearer" + localStorage.getItem('token');
        if (token) {
          config.headers['Authorization'] = token;
        }
        return config;
      })
    }

    //遮罩层
    if (isLoading) {
      loadingInstance = Loading.service({
        text: "努力加载中,请稍等..."
      });
    }
    axios.get(url, options).then((response) => {
      if (response.data.code == "999" || response.data.code == '998') {
        logouttime++
        if (logouttime == 1) {
          let options = {
            message: "登录信息已过期，请重新登录",
            type: "warning"
          }
          Message.warning(options)
          router.push({ path: "/authFront/login" });
        }

      }
      // 响应成功回调
      if (response.status == 0) {
        let options = {
          message: response.msg,
          duration: 1000
        }
        Message.warning(options)
      } else if (response.data.status == 500) {
        MessageBox({
          title: '系统提示',
          message: '错误码: ' + response.data.status + '<br/>' + '错误信息: ' + response.data.msg,
          confirmButtonText: '确定',
          closeOnPressEscape: false,
          showCancelButton: false,
          dangerouslyUseHTMLString: true
        }).then(() => {

        }).catch(() => {
          loadingInstance.close();
        });
      } else if (response.code == 200) {
        loadingInstance.close();
      } else {
        sucCb(response.data);
      }
      if (isLoading) {
        if (url.indexOf("getJobListByRoad") == -1 && url.indexOf("getPushJobMessageList") == -1 && url.indexOf('closeMessage') == -1) {
          setTimeout(() => {
            loadingInstance.close();
          }, 1000);
        }

      }
    }, (response) => {
      // errorCb(response);
      if (isLoading) {
        setTimeout(() => {
          loadingInstance.close();
        }, 2000);
      }
      //401 token过期
      //403 没有权限

      // if (response.response.status == "401") {
      //   myindex++;
      //   if (myindex == 2) {
      //     let options = {
      //       message: "登录信息已过期，请重新登录",
      //       duration: 1000
      //     }
      //     Message.warning(options)
      //   }

      //   router.push({ path: '/' })
      //   return false;

      // }
      // if (response.response.status == "403") {
      //   let options = {
      //     message: "没有权限访问此页面",
      //     duration: 1000
      //   }
      //   Message.warning(options)
      //   router.push({ path: '/homepage' })
      //   return false;
      // }
    })
  },

  /**
   * 统一接口处理：post请求方法封装。this.$http.get(url, [options])
   * @param url { String } -必选 接口url
   * @param body { Object } -必选 含官方的所有body对象，可为null。传参时不需要参数名，例如body为{key:11}
   * @param options { Object } -必选 含官方的所有options对象，可为null。传参为{params:{key:11}}
   * @param sucCb { Function } -必选 成功回调
   * @param errorCb { Function } -可选 失败回调
   * @param isLoading { Boolean } -可选 是否显示加载状态
   * @param isLogin { Boolean } -可选 是否登录信息（
   */
  post: function (url, body, options = {}, sucCb, errorCb, isLoading = true, isLogin) {

    if (navigator.onLine != true) {
      router.push("/404");
      return false;
    }
    var loadingInstance;

    if (!url) {
      return false;
    }
    if (url.indexOf("login") == -1) {
      // let token = "Bearer" + store.getters.token;

      axios.interceptors.request.use(function (config) {
        let token = "Bearer" + localStorage.getItem('token');

        if (token) {
          config.headers['Authorization'] = token;
        }
        return config;
      })
    }

    //遮罩层
    if (isLoading) {
      loadingInstance = Loading.service({
        text: "努力加载中,请稍等..."
      });
    }
    axios.post(url, body, options).then((response) => {
      if (response.data.code == "999" || response.data.code == '998') {
        logouttime++
        if (logouttime == 1) {
          let options = {
            message: "登录信息已过期，请重新登录",
            type: "warning"
          }
          Message.warning(options)
          router.push({ path: "/authFront/login" });
        }

      }
      if (response.data.errorCode == "00000001014") {
        let options = {
          message: "登录信息已过期，请重新登录",
          type: "warning"
        }
        Message.warning(options)
        router.push({ path: '/login' })
        loadingInstance.close();
        return false;
      }
      // 响应成功回调
      if (response.data.status == 0) {
        if (response.data.msg == "system_login_noUserInfo") {
          if (noUserTipIsShow) {
            noUserTipIsShow = false;
            MessageBox({
              title: '系统提示',
              message: '错误码: ' + response.data.status + '<br/>' + '错误信息: ' + response.data.msg,
              confirmButtonText: '确定',
              closeOnPressEscape: false,
              showCancelButton: false,
              dangerouslyUseHTMLString: true
            }).then(() => {
              store.dispatch('LogOut');
              router.push({
                path: '/myHome'
              })

            }).catch(() => {
              loadingInstance.close();
            });
          }
        } else {
          MessageBox({
            title: '系统提示',
            message: '错误码: ' + response.data.status + '<br/>' + '错误信息: ' + response.data.msg,
            confirmButtonText: '确定',
            closeOnPressEscape: false,
            showCancelButton: false,
            dangerouslyUseHTMLString: true
          }).then(() => {

          }).catch(() => {
            loadingInstance.close();
          });
        }

      } else if (response.data.status == 500) {
        MessageBox({
          title: '系统提示',
          message: '错误码: ' + response.data.status + '<br/>' + '错误信息: ' + response.data.msg,
          confirmButtonText: '确定',
          closeOnPressEscape: false,
          showCancelButton: false,
          dangerouslyUseHTMLString: true
        }).then(() => {

        }).catch(() => {

        });
      } else {

        sucCb(response.data);
      }
      if (isLoading) {
        loadingInstance.close();
      }

    }, (response) => {
      // 响应错误回调
      // errorCb(response);
      if (isLoading) {
        loadingInstance.close();
      }
      // if (response.response.status == "401") {
      //   myindex++;
      //   if (myindex == 2) {
      //     let options = {
      //       message: "登录信息已过期，请重新登录",
      //       duration: 1000
      //     }
      //     Message.warning(options)
      //   }
      //   router.push({ path: '/' })
      // }
      // if (response.response.status == "403") {
      //   let options = {
      //     message: "没有权限访问此页面",
      //     duration: 1000
      //   }
      //   Message.warning(options)
      //   router.push({ path: '/homepage' })

      // }
    })
  },

  noloadpost: function (url, body, options = {}, sucCb, errorCb, isLoading = true, isLogin) {
    if (navigator.onLine != true) {
      router.push("/404");
      return false;
    }
    var loadingInstance;
    if (!url) {
      return false;
    }
    if (url.indexOf("login") == -1) {
      axios.interceptors.request.use(function (config) {
        let token = store.getters.token;
        if (token) {
          // config.headers['Authorization'] = 'Bearer ' + token;
          config.headers['Authorization'] = token;
        }
        return config;
      })
    }

    //遮罩层
    if (isLoading) {
      loadingInstance = Loading.service({
        text: "努力加载中,请稍等..."
      });
    }
    axios.post(url, body, options).then((response) => {
      if (response.data.errorCode == "00000001014") {
        let options = {
          message: "登录信息已过期，请重新登录",
          type: "warning"
        }
        Message.warning(options)
        router.push({ path: '/login' })
        loadingInstance.close();
        return false;
      }
      // 响应成功回调
      if (response.data.status == 0) {
        if (response.data.msg == "system_login_noUserInfo") {
          if (noUserTipIsShow) {
            noUserTipIsShow = false;
            MessageBox({
              title: '系统提示',
              message: '错误码: ' + response.data.status + '<br/>' + '错误信息: ' + response.data.msg,
              confirmButtonText: '确定',
              closeOnPressEscape: false,
              showCancelButton: false,
              dangerouslyUseHTMLString: true
            }).then(() => {
              store.dispatch('LogOut');
              router.push({
                path: '/myHome'
              })

            }).catch(() => {
              loadingInstance.close();
            });
          }
        } else {
          MessageBox({
            title: '系统提示',
            message: '错误码: ' + response.data.status + '<br/>' + '错误信息: ' + response.data.msg,
            confirmButtonText: '确定',
            closeOnPressEscape: false,
            showCancelButton: false,
            dangerouslyUseHTMLString: true
          }).then(() => {

          }).catch(() => {
            loadingInstance.close();
          });
        }

      } else if (response.data.status == 500) {
        MessageBox({
          title: '系统提示',
          message: '错误码: ' + response.data.status + '<br/>' + '错误信息: ' + response.data.msg,
          confirmButtonText: '确定',
          closeOnPressEscape: false,
          showCancelButton: false,
          dangerouslyUseHTMLString: true
        }).then(() => {

        }).catch(() => {

        });
      } else {

        sucCb(response.data);
      }
      if (isLoading) {
        loadingInstance.close();
      }

    }, (response) => {
      // 响应错误回调
      // errorCb(response);
      if (isLoading) {
        loadingInstance.close();
      }
      if (response.errorCode == "403") {
        let options = {
          message: response.msg,
          duration: 1000
        }
        Message.warning(options)
      }
    })
  },
};



// WEBPACK FOOTER //
// ./src/utils/http.js